/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const YouTube = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--youtube"
      {...props}
    >
      <path
        d="M16.5405 4.18019C16.45 3.81784 16.2717 3.48713 16.0235 3.22117C15.7752 2.95521 15.4657 2.76332 15.1259 2.66471C13.875 2.30664 8.875 2.30664 8.875 2.30664C8.875 2.30664 3.875 2.30664 2.62409 2.66471C2.28429 2.76332 1.97477 2.95521 1.72653 3.22117C1.47828 3.48713 1.3 3.81784 1.20955 4.18019C0.875 5.51761 0.875 8.30664 0.875 8.30664C0.875 8.30664 0.875 11.0957 1.20955 12.4331C1.3 12.7954 1.47828 13.1261 1.72653 13.3921C1.97477 13.6581 2.28429 13.85 2.62409 13.9486C3.875 14.3066 8.875 14.3066 8.875 14.3066C8.875 14.3066 13.875 14.3066 15.1259 13.9486C15.4657 13.85 15.7752 13.6581 16.0235 13.3921C16.2717 13.1261 16.45 12.7954 16.5405 12.4331C16.875 11.0957 16.875 8.30664 16.875 8.30664C16.875 8.30664 16.875 5.51761 16.5405 4.18019Z"
        fill="#FF0302"
      />
      <path d="M6.875 10.9735V5.64014L12.2083 8.3068L6.875 10.9735Z" fill="#FEFEFE" />
    </svg>
  );
};

YouTube.displayName = "YouTube";

export default YouTube;
